import {
  restoreLogin,
  restoreLoginSuccess,
  restoreLoginFailure,
  resetLogin,
  resetLoginSuccess
} from "../../actions/RestoreLogin";
import cookie from "react-cookies";
import { checkCodeSuccess } from "../../actions/CheckCode";
import { put, takeEvery, call } from "redux-saga/effects";
import {
  getUserFailure,
  getUserSuccess
} from "../../actions/GetUser/getUserActions";
import { getUserRequest } from "../../../api/requests/GetUser/getUserRequest";
import { tokenHasExpired } from "../../../../../common/utils/tokenHasExpired";

function* restoreLoginSaga(action) {
  try {
    const localStorage = window.localStorage;
    if (localStorage.user) {
      const user = JSON.parse(localStorage.user);
      const session =
        localStorage.getItem("session") &&
        JSON.parse(localStorage.getItem("session"));
      yield put(restoreLoginSuccess(user));
      const expiresIn = session.expires_in;
      const createdAt = session.created_at;
      const hasTokenExpired = tokenHasExpired({
        expiresIn: expiresIn,
        createdAt: createdAt
      });
      if (!hasTokenExpired) {
        user.hasTokenExpired = !hasTokenExpired;
        yield call(getUserSaga, user.id);
        yield put(restoreLoginSuccess(user));
      }
    } else {
      yield put(restoreLoginFailure());
    }
  } catch (error) {
    console.error("Restore Login Saga error: ", error.message);
    yield put(restoreLoginFailure(error));
  }
}

function* getUserSaga(id) {
  try {
    const user = yield call(getUserRequest, id);
    yield put(getUserSuccess(user.data));
  } catch (e) {
    yield put(getUserFailure(e));
  }
}

function* resetLoginSaga(action) {
  try {
    const localStorage = window.localStorage;
    if (localStorage.user) {
      localStorage.clear();
      localStorage.removeItem("session");
      // localStorage.removeItem('user');
      yield put(resetLoginSuccess());
      yield put(restoreLogin());
    }
  } catch (err) {
    // ignore
  }
}

export function* restoreLoginWatcher() {
  //Попытка восстановить Login
  yield takeEvery(restoreLogin.toString(), restoreLoginSaga);
  yield takeEvery(resetLogin.toString(), resetLoginSaga);
}
